import { Avatar, Box, Button, IconButton, Tooltip, Typography } from '@mui/material';
import BarChartIcon from '@mui/icons-material/BarChart';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import useTemplateSx from '../../hooks/useTemplateSx';

export default function TemplateNameCell({ row, onOpenDetails, onOpenInsights }) {
  const styles = useTemplateSx();
  const name = row?.name?.toString() ?? '';
  const description = row?.description?.trim();
  const botNumber = row?.bot_number?.toString()?.trim() ?? '';
  const appName = row?.app_name?.trim() || '';
  const channelLabel = appName && botNumber
    ? `${appName} (${botNumber})`
    : appName || botNumber || row?.organisation_name?.trim() || row?.company_name?.trim() || '';
  const canOpenDetails = Boolean(onOpenDetails);
  const showInsights = Boolean(onOpenInsights);

  const handleOpenDetails = (event) => {
    event.stopPropagation();
    onOpenDetails?.(row);
  };

  const handleOpenInsights = (event) => {
    event.stopPropagation();
    onOpenInsights?.(row);
  };

  return (
    <Box
      sx={[
        styles.templateNameCellWrapper,
        showInsights ? styles.templateNameCellHoverActions : null,
      ]}
    >
      <Box sx={styles.templateNameCell}>
        <Avatar sx={styles.templateNameAvatar}>{(name[0] || '?').toUpperCase()}</Avatar>
        <Box sx={styles.templateNameTextBlock}>
          <Box sx={{ display: 'flex', alignItems: 'center', minWidth: 0, width: '100%', gap: 0.5 }}>
            <Typography
              component="span"
              sx={{
                ...styles.templateNameLink,
                ...(canOpenDetails
                  ? null
                  : { cursor: 'default', color: 'text.primary' }),
              }}
              onClick={canOpenDetails ? handleOpenDetails : undefined}
            >
              {name}
            </Typography>
            {description ? (
              <Tooltip
                title={description}
                placement="top"
                arrow
                slotProps={{
                  tooltip: {
                    sx: {
                      maxWidth: 320,
                      fontSize: '0.75rem',
                      lineHeight: 1.45,
                    },
                  },
                }}
              >
                <IconButton
                  size="small"
                  aria-label="Template description"
                  onClick={(event) => event.stopPropagation()}
                  sx={styles.templateNameInfoIcon}
                >
                  <InfoOutlinedIcon sx={{ fontSize: 16 }} />
                </IconButton>
              </Tooltip>
            ) : null}
          </Box>
          {channelLabel ? (
            <Typography sx={styles.templateNameSubtitle}>{channelLabel}</Typography>
          ) : null}
          {showInsights ? (
            <Button
              className="template-view-performance"
              size="small"
              variant="text"
              startIcon={<BarChartIcon sx={{ fontSize: 15 }} />}
              onClick={handleOpenInsights}
              sx={styles.templateNameInsightsButton}
            >
              View performance
            </Button>
          ) : null}
        </Box>
      </Box>
    </Box>
  );
}
